import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Output,
} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {AllocationRequest} from "../../../../../model/clearing/allocation/allocation-request";
import {ClearingAllocationService} from "../../../../../services/clearing/clearing-allocation.service";
import {CcBaseComponent} from "../../../../../crystal-elements/cc-base.component";
import {FormFieldConfig} from "../../../../../model/api/form-field-config";
import {FormFieldGroupConfig} from "../../../../../model/api/form-field-group-config";
import {Order} from "../../../../../model/clearing/order";
import TYPE = FormFieldConfig.TYPE;

@Component({
  selector: 'app-clearing-move-order-form',
  templateUrl: './move-order-form.component.html',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MoveOrderFormComponent extends CcBaseComponent {

  transPartKey: string = 'clearing.order';

  formLoading: boolean = false;

  formSubmitted: boolean = true;

  formConfig: FormFieldGroupConfig[] = [];

  dialogFormTitle: string = '';

  formRecord: {} | any;

  loadingProgressValue: number = 100;
  dialogFormVisible: boolean = false;

  @Output()
  onSavedForm = new EventEmitter<any>();

  manageAps: boolean = false;

  constructor(cdref: ChangeDetectorRef,
              private allocationService: ClearingAllocationService,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService) {
    super(cdref, messageService, translateService);
    this.formRecord = {};
  }

  protected refreshConfigs() {
    this.formConfig = [
      {
        group: '',
        fields: [
          {
            field: 'orderReference',
            column: 6,
            type: TYPE.TEXT,

            input: (event, formRecord, inputField) => {
              var start = inputField.selectionStart;
              var end = inputField.selectionEnd;
              inputField.value = inputField.value.toUpperCase();
              formRecord.orderReference = inputField.value;
              inputField.setSelectionRange(start, end);
            },
            focused: this.formRecord.moveOrderReference,
            hidden: record => !record.moveOrderReference
          },
          {
            field: 'apsGroupId',
            filter: true,
            column: this.formRecord.moveOrderReference ? 6 : 12,
            type: TYPE.TEXT,
            leftButton: {
              icon: 'fa-solid fa-arrow-right',
              command: event => this.formRecord.apsGroupId = this.formRecord.orderReference
            },
            input: (event, formRecord, inputField) => {
              var start = inputField.selectionStart;
              var end = inputField.selectionEnd;
              inputField.value = inputField.value.toUpperCase();
              formRecord.apsGroupId = inputField.value;
              inputField.setSelectionRange(start, end);
            },
            focused: !this.formRecord.moveOrderReference,
          },]
      }];
  }

  public open(selectedIds: string[], apsGroupId: string, orderReference?: string, manageOrderReference: boolean = false): void {
    if (selectedIds && selectedIds.length > 0) {
      const newFormRecord = {
        clearingIds: selectedIds,
        moveOrderReference: manageOrderReference,
        orderReference: orderReference && orderReference.length > 0 ? orderReference : '',
        apsGroupId: apsGroupId
      }
      this.openWithRecord(newFormRecord);
    }
  }

  public openWithRecord(newFormRecord: any): void {
    if (newFormRecord.moveOrderReference) {
      this.dialogFormTitle = this.getTranslation('page.' + this.transPartKey + '.table.move_order_reference');
    } else {
      this.dialogFormTitle = this.getTranslation('page.' + this.transPartKey + '.table.move_order_aps');
    }
    this.formRecord = newFormRecord;
    this.refreshConfigs();
    this.dialogFormVisible = true;
    this.markForCheck();
  }

  save() {
    this.formLoading = true;
    if (!this.formRecord.orderReference)
      this.formRecord.orderReference = '';
    if (!this.formRecord.apsGroupId)
      this.formRecord.apsGroupId = '';
    this.allocationService.moveOrders(this.formRecord.clearingIds, this.formRecord.apsGroupId, this.formRecord.orderReference).subscribe(validation => {
      if (validation.success) {
        this.onSavedForm.emit({taskId: validation.item, formRecord: Object.assign({}, this.formRecord)});
        this.closeDialogForm();
      } else {
        this.errorMessage(validation.message);
      }
      this.formLoading = false;
    });
  }

  closeDialogForm(): void {
    this.dialogFormVisible = false;
    this.markForCheck();
  }

}
